module.exports = __webpack_public_path__ + "img/horizontal_7_5_6000.cb80826a.png";